import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Add, ArrowBack, Done, Edit } from "@mui/icons-material";
import { MainContext } from "../../../../../Context/MainCtx";
import { ACTUALIZAR_RED, CREAR_RED } from "../graphql/mutations";
import { useMutation } from "@apollo/client";
import { CircularProgress } from "@mui/material";
import GetUnidadesField from "./GetUnidadesField";

export default function NuevaRedSocial({
  edit,
  data,
  refetch,
  inputMode = false,
}) {
  const [open, setOpen] = React.useState(false);
  const [redSocial, setRedSocial] = React.useState({
    redSocial: "",
    enlace: "",
    unidadNegocio: "",
  });
  const [loading, setLoading] = React.useState(false);
  const { snackMessage, tokenDecoded } = React.useContext(MainContext);
  const [crearRedSocial] = useMutation(CREAR_RED);
  const [actualizarRedSocial] = useMutation(ACTUALIZAR_RED);

  const handleOpen = () => {
    setOpen(true);
    if (edit) {
      const { _id, idEmpresa, ...newData } = data;
      setRedSocial(newData);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setRedSocial({
      redSocial: "",
      enlace: "",
      unidadNegocio: "",
    });
  };

  const handleChangeRed = (e) => {
    const { name, value } = e.target;
    setRedSocial((st) => ({ ...st, [name]: value }));
  };

  const handleSaveRed = async (e) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      const input = { ...redSocial };
      setLoading(true);
      if (!edit) {
        //si es nuevo
        const res = await crearRedSocial({
          variables: {
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            input,
          },
        });
        snackMessage({
          message: res.data.crearRedSocial.message,
          variant: "success",
        });
      } else {
        //si va a actualizar
        const res = await actualizarRedSocial({
          variables: {
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            idRedSocial: data._id,
            input,
          },
        });
        snackMessage({
          message: res.data.actualizarRedSocial.message,
          variant: "success",
        });
      }
      refetch();
      setLoading(false);
      handleClose();
    } catch (err) {
      console.log(err.networkError?.result);
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      {edit ? (
        <IconButton onClick={handleOpen}>
          {loading ? <CircularProgress size={20} color="inherit" /> : <Edit />}
        </IconButton>
      ) : inputMode ? (
        <IconButton color="primary" onClick={handleOpen} sx={{ mx: 1 }}>
          <Add />
        </IconButton>
      ) : (
        <Button
          startIcon={<Add />}
          color="primary"
          variant="contained"
          onClick={handleOpen}
          size="small"
          disableElevation
          sx={{ textTransform: "none", minWidth: 40 }}
        >
          Nueva
        </Button>
      )}
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        ModalProps={{
          componentsProps: {
            backdrop: {
              sx: { background: "none" },
            },
          },
        }}
        PaperProps={{
          elevation: 1,
          sx: { width: { xs: "100vw", md: "40vw" } },
        }}
      >
        <Toolbar variant="dense" />
        <DialogTitle component="div">
          <Stack spacing={1} direction="row" alignItems="center">
            <IconButton onClick={() => handleClose()}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6">{edit ? `Editar` : "Nueva"}</Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Done />
                )
              }
              variant="contained"
              disableElevation
              sx={{ textTransform: "none" }}
              size="small"
              type="submit"
              form="red-form"
            >
              Guardar
            </Button>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ py: 0 }}>
          <form id="red-form" onSubmit={handleSaveRed}>
            <TextField
              label="Red social"
              name="redSocial"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              onChange={handleChangeRed}
              value={redSocial.redSocial}
              required
            />
            <TextField
              label="Enlace"
              name="enlace"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              onChange={handleChangeRed}
              value={redSocial.enlace}
            />
            <GetUnidadesField
              redSocial={redSocial}
              setRedSocial={setRedSocial}
            />
          </form>
        </DialogContent>
      </Drawer>
    </div>
  );
}
